export default {
	bizOrder: {
		title: 'Gestión de Órdenes de Trabajo',
		query: {
			title: 'Nombre de Orden de Trabajo',
			status: 'Estado de Procesamiento'
		},
		table: {
			title: 'Título de Orden de Trabajo',
			deviceName: 'Nombre del Equipo',
			deviceNo: 'Número de Equipo',
			status: 'Estado de Orden de Trabajo',
			toPersonName: 'Responsable',
			fromPersonName: 'Solicitante',
			createTime: 'Tiempo de Creación',
			wlevel: 'Nivel de Alarma',
			warnCount: 'Conteo de Alarmas',
			action: 'Acción'
		},
		buttons: {
			add: 'Agregar',
			deleteBatch: 'Eliminar en Lote',
			handle: 'Manejar',
			detail: 'Detalles',
			close: 'Cerrar',
			cancel: 'Cancelar',
			confirm: 'Confirmar',
			diagnosis: 'Diagnóstico',
			delete: 'Eliminar'
		},
		form: {
			title: 'Título',
			content: 'Contenido',
			remark: 'Observación',
			attachmentList: 'Archivo Adjunto'
		},
		dialog: {
			add: 'Agregar Orden de Trabajo',
			update: 'Completar Orden de Trabajo',
			detail: 'Detalles de Orden de Trabajo',
			warnInfo: 'Información de Alarma'
		},
		messages: {
			operationSuccess: 'Operación completada con éxito',
			deleteConfirm: '¿Está seguro de que desea eliminar?',
			batchDeleteConfirm: '¿Está seguro de que desea eliminar en lote?'
		},
		warnList: {
			title: 'Lista de Alarmas',
			warnTitle: 'Título de Alarma',
			pointName: 'Nombre de Punto de Sensor',
			pointId: 'ID de Punto de Sensor',
			dataType: 'Tipo de Dato',
			wlevel: 'Nivel de Alarma',
			handleStatus: 'Estado',
			startTime: 'Tiempo de Inicio',
			predTime: 'Última Alarma',
                        eigenKey: 'Valores característicos',
			content: 'Contenido',
			standardData: 'Valor de Referencia',
			predData: 'Valor Real',
			warnCount: 'Conteo de Alarmas',
			type: 'Tipo de Alarma',
			suggest: 'Sugerencia',
			warnType: 'Clasificación de Alarma'
		}
	}
}
